import React, { memo } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  title: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "stretch",
    marginBottom: theme.spacing(1),
  },
  title__subtext: { textAlign: "center", flexGrow: 2 },
  title__text: { textAlign: "center", flexGrow: 2, fontWeight: "bold" },
  container: { padding: theme.spacing(0) },
  text__indent: { textIndent: theme.spacing(5) },
  text__blue: { color: "#3f51b5", fontWeight: "bold" },
  text__red: { color: "#8b0000", fontWeight: "bold" },
  text__bold: { fontWeight: "bold" },
  list: { listStyleType: "none", fontSize: "1rem", margin: 0 },
  list__num: { listStyleType: "decimal", fontSize: "1rem", margin: 0 },
  list__line: { listStyleType: '" - "', fontSize: "1rem", margin: 0 },
  list__point: { fontSize: "1rem", margin: 0 },
}));

export const HelpWithBlockedLinks = memo(() => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.title}>
        <ul className={classes.list__point}>
          <li>
            Если Вы используете мобильный телефон, то попробуйте зайти с
            компьютера
          </li>
          <li>В настройках браузера разрешить всплывающие окна</li>
        </ul>
        <div className={classes.container}>
          <Typography className={classes.title__subtext}>
            Разрешить всплывающие окна в браузере <span className={classes.text__bold}>Chrome на устройстве Android</span>
          </Typography>
          <ol className={classes.list__num}>
            <li>Откройте браузер Chrome на устройстве Android.</li>
            <li>
              Справа от адресной строки нажмите на значок с тремя точками
              <span className={classes.text__bold}>«Настройки»</span>.
            </li>
            <li>
              Выберите <span className={classes.text__bold}>«Настройки сайта», «Всплывающие окна и переадресация»</span>.
            </li>
            <li>Установите переключатель в положение <span className={classes.text__bold}>«отключено»</span>.</li>
          </ol>
          <Typography className={classes.title__subtext}>
            Разрешить всплывающие окна в браузере <span className={classes.text__bold}>Safari</span>
          </Typography>
          <ol className={classes.list__num}>
            <li>Перейдите в раздел <span className={classes.text__bold}>«Настройки»- «Приложения» - «Safari»</span>.</li>
            <li>
              Включите или выключите параметр <span className={classes.text__bold}>«Блокировка всплывающих окон»</span>
            </li>
          </ol>
          <Typography className={classes.title__subtext}>
            Разрешить всплывающие окна в браузере <span className={classes.text__bold}>Chrome на компьютере</span>
          </Typography>
          <ol className={classes.list__num}>
            <li>Откройте браузер Chrome на компьютере.</li>
            <li>
              В правом верхнем углу окна нажмите на <span className={classes.text__bold}>значок с тремя точками
              «Настройки».</span>
            </li>
            <li>
              Выберите <span className={classes.text__bold}>«Конфиденциальность и безопасность», «Настройки сайта»,
              «Всплывающие окна и переадресация».</span>
            </li>
            <li>
              Включите параметр <span className={classes.text__bold}>«Разрешить сайтам показывать всплывающие окна и
              использовать переадресацию».</span>
            </li>
          </ol>
          <Typography className={classes.title__subtext}>
            Разрешить всплывающие окна в браузере <span className={classes.text__bold}>Mozilla Firefox на компьютере</span>
          </Typography>
          <ol className={classes.list__num}>
            <li>Откройте браузер Mozilla Firefox на компьютере.</li>
            <li>Нажмите кнопку <span className={classes.text__bold}>«Меню»</span> и выберите <span className={classes.text__bold}>«Настройки»</span></li>
            <li>Выберите панель <span className={classes.text__bold}>«Приватность и защита»</span></li>
            <li>
              Прокрутите до раздела <span className={classes.text__bold}>«Разрешения»</span>. Снимите флажок рядом с
              <span className={classes.text__bold}>«Блокировать всплывающие окна»</span>.
            </li>
          </ol>
        </div>
      </div>
    </>
  );
});
